module.exports = __webpack_public_path__ + "img/macau.98978a3c.png";